module.exports = __webpack_public_path__ + "logo.64187298.png";